<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="read"> </p>
<p class="FMH1"><span href="#/xhtml/contents#c_read" title="Link target outside of Sample"><span class="ePub-B">N</span><span class="ePub-SC-B">OTE TO THE</span><span class="ePub-B"> R</span><span class="ePub-SC-B">EADER</span></span></p>
<p class="IMG1" id="img2"><img alt="image" height="243" src="images/L-2a_BW_2_fmt.jpeg" width="350"/></p>
<p class="TNI-4">The way we use words to label people and identify things is important. In this book, I use the term <span class="ePub-I">enslaved person</span> instead of <span class="ePub-I">slave</span> when referring to individuals who, under the laws of the day, were the legal property of other people. It is very different to say, for example, that “William Lee was born enslaved” than it is to say, “William Lee was Washington’s slave.” This critical distinction reflects how we think about the people who were victims trapped in a powerful system. To say that people were <span class="ePub-I">enslaved</span> means this condition was forced on them; it does not define who they were. It is meant as a respectful term for the individuality of the enslaved people.</p>
<p class="TX">Throughout this book, the actual words of formerly enslaved people are sometimes used as they were recorded many years ago. Often their words were set down in a style that attempted to capture the original regional dialect and grammar. That not only can be confusing to today’s readers but sometimes makes the speaker appear ignorant. I have occasionally used modern spellings to clarify the meaning of these personal accounts and recollections. For instance, if a person had once said “’belled,” that has been changed to “rebelled,” and the word “Massa” appears as “Master.” This was done only to make the words and experiences of these people clear<a id="x.2500">.</a></p><a id="x.2500">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// reader.vue?52455e12